import { render, staticRenderFns } from "./PreviewIphoneNotification.vue?vue&type=template&id=a63e7534&scoped=true&lang=pug&"
import script from "./PreviewIphoneNotification.vue?vue&type=script&lang=js&"
export * from "./PreviewIphoneNotification.vue?vue&type=script&lang=js&"
import style0 from "./PreviewIphoneNotification.vue?vue&type=style&index=0&id=a63e7534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63e7534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
